import { toast } from "vue3-toastify";

const ToastService = {
    info(message, options = {}) {
        toast(message, {
            autoClose: 4000,
            hideProgressBar: true,
            type: toast.TYPE.INFO,
            position: toast.POSITION.BOTTOM_RIGHT,
            ...options
        });
    },

    error(message, options = {}) {
        toast(message, {
            hideProgressBar: true,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_RIGHT,
            ...options
        });
    },
};

export default ToastService;